// client/src/components/common/LoadingSpinner.js
import React from 'react';
import './LoadingSpinner.css'; // Create this CSS file

function LoadingSpinner() {
    return (
        <div className="loading-spinner">
            <div className="spinner-dot"></div>
            <div className="spinner-dot"></div>
            <div className="spinner-dot"></div>
        </div>
    );
}

export default LoadingSpinner;